import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import CInput from '@/components/shared/CInput';
import CSelect, { type CSelectItem, valueReducer } from '@/components/shared/CSelect';
import CalendarColorField from './CalendarColorField.vue';
import CalendarFontField from './CalendarFontField.vue';
import CalendarStrokeField from './CalendarStrokeField.vue';
import type { CalendarConfig, CalendarStrokeValue, CalendarTextAlign, CalendarTitlePrefix } from './types';


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarTitleStyleFields',
  props: {
    config: null,
    prefix: null,
    disabled: { type: Boolean }
  },
  emits: ["update"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'update', value: Partial<CalendarConfig>): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    config: CalendarConfig;
    prefix: CalendarTitlePrefix;
    disabled?: boolean;
};

const ALIGN_OPTIONS: CSelectItem<CalendarTextAlign>[] = [
    { label: 'Left', value: 'start' },
    { label: 'Center', value: 'middle' },
    { label: 'Right', value: 'end' }
];





const keys = computed(() => ({
    font: `${props.prefix}FontPath`,
    size: `${props.prefix}FontSize`,
    margin: `${props.prefix}TopMargin`,
    color: `${props.prefix}Color`,
    strokeWidth: `${props.prefix}StrokeWidth`,
    strokeColor: `${props.prefix}StrokeColor`
} as const));

// The lib renders the combined title always centered, only year/month support alignment
const alignKey = computed(() => (props.prefix === 'yearMonth' ? undefined : (`${props.prefix}Align` as const)));

// Unset alignment falls back to the right side in the lib
const align = computed(() => (alignKey.value ? props.config[alignKey.value] ?? 'end' : undefined));

const update = (key: keyof CalendarConfig, value: unknown) => emit('update', { [key]: value });

const onStrokeUpdate = ({ width, color }: CalendarStrokeValue) => {
    emit('update', { [keys.value.strokeWidth]: width, [keys.value.strokeColor]: color });
};

return { __sfc: true,ALIGN_OPTIONS, props, emit, keys, alignKey, align, update, onStrokeUpdate, CInput, CSelect, valueReducer, CalendarColorField, CalendarFontField, CalendarStrokeField }
}

})